<template>
  <appMajority :is-new="false" />
</template>

<script>
import appMajority from "@/components/catalogs/majorities/Majority";

export default {
  components: {
    appMajority,
  },
};
</script>
